<template>
  <div class="border-ce5 mt-16">
    <div class="settle-wrap">
      <div class="settle-wrap-item">
        <span
          class="font-c666"
        >{{TLang('totalProduct1', 'orderConfirm')}}
          <em class="font-s14">{{ settleAccountInfo.orderTotalNums }}</em>
          {{ TLang("totalProduct2", "orderConfirm") }}，{{ TLang('商品总价', 'list') }}({{ settleAccountInfo.union_name }}):
        </span>
        <span class="text-num-c111">{{
          settleAccountInfo.orderTotalGoodsAmount
        }}</span>
      </div>
      <div class="settle-wrap-item mt-12">
        <span class="font-c666">
          {{ TLang('运费', 'orderConfirm') }}({{ settleAccountInfo.union_name }}):
        </span>
        <span class="text-num-c111">{{
          settleAccountInfo.orderTotalFeight
        }}</span>
      </div>
      <div class="settle-wrap-item mt-12">
        <span class="font-c666">
          {{ TLang('应付金额', 'orderConfirm') }}
        </span>
        <span>
          <img
            :src="settleAccountInfo.fudou"
            alt=""
            class="fudou-15"
          />
          <em class="text-num-bold-red font-s20">{{
            settleAccountInfo.orderAccountPayable
          }}</em>
        </span>
      </div>
      <div class="settle-wrap-item mt-20 clearfix">
        <div
          class="btn-theme-w150 fr"
          @click="
            () => {
              onCreateOrder();
            }
          "
        >
          {{ TLang('提交订单', 'list') }}
        </div>
      </div>
      <div class="mt-12 text-right">
        <span
          class="dib mr-8 font-c999"
        > {{ TLang('收货信息', 'orderConfirm') }}：{{ settleAccountInfo.consigneeInfo }}</span>
        <span class="font-c999">{{ settleAccountInfo.addressInfo }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'OrderSettle',
  props: {
    settleAccountInfo: Object,
  },
  computed: {
    ...mapState('orderConfirm', ['createOrderParameter']),
  },
  created() {},
  methods: {
    onCreateOrder() {
      const { addressId } = this.createOrderParameter;
      let isCreateOrder = true;
      let errorMsg = '';
      if (!addressId) {
        this.$message.error(this.TLang('请选择用户的配送地址', 'orderConfirm'));
        return;
      }

      if (
        this.createOrderParameter &&
        this.createOrderParameter.buyInfoList
      ) {
        this.createOrderParameter.buyInfoList.map(item => {
          if (item.deliveryWay === '3' && !item.expectDeliveryTime) {
            errorMsg = this.TLang('请选择发货时间', 'orderConfirm');
            isCreateOrder = false;
            return;
          }

          if (item.deliveryWay === '3' && item.expectDeliveryTime) {
            const m = new Date(item.expectDeliveryTime).getMonth() === new Date().getMonth();
            const d = new Date(item.expectDeliveryTime).getDate() === new Date().getDate();
            const splitcutOffTimeStr = item.cutOffTimeStr ? item.cutOffTimeStr.split(':') : [0,0];
            let timeout = false;
            if (new Date().getHours() === Number(splitcutOffTimeStr[0]) && new Date().getMinutes() > Number(splitcutOffTimeStr[1])) {
              timeout = true;
            } else if (new Date().getHours() > Number(splitcutOffTimeStr[0])) {
              timeout = true;
            }

            if (m && d && timeout && item.deliveryWay === '3') {
              errorMsg = this.TLang('请修改发货时间', 'orderConfirm');
              isCreateOrder = false;
              return;
            }
          }
        });
      }


      if (!isCreateOrder) {
        this.$message.error(errorMsg);
        return;
      }

      this.$parent.createOrderAction();
    },
  },
};
</script>

<style lang="less" scoped>
.settle-wrap {
  .card-theme;
  padding: 24px;

  .settle-wrap-item {
    text-align: right;
    span {
      display: inline-block;

      &:last-of-type {
        width: 11%;
      }
    }
  }
}
</style>
